import axiosInstance from '../lib/api/axiosInstance';
import { OverviewApiResponse, WebsiteOverviewApiResponse } from '../types/overview';

export interface GetOverviewRevenueParams {
  solution: 'ssp' | 'adblock' | 'noconsent';
  period: 'yesterday' | 'last7days' | 'last30days' | 'lastMonth' | 'custom';
  customStartDate?: string;
  customEndDate?: string;
  showVariation: boolean;
}

// Récupérer les données de revenus par network pour l'Overview
export const getOverviewRevenue = async (params: GetOverviewRevenueParams): Promise<OverviewApiResponse> => {
  try {
    const queryParams = new URLSearchParams({
      solution: params.solution,
      period: params.period,
      showVariation: params.showVariation.toString()
    });

    // Ajouter les dates personnalisées si période est 'custom'
    if (params.period === 'custom') {
      if (params.customStartDate) {
        queryParams.append('customStartDate', params.customStartDate);
      }
      if (params.customEndDate) {
        queryParams.append('customEndDate', params.customEndDate);
      }
    }

    const response = await axiosInstance.get(`/overview/revenue?${queryParams.toString()}`);
    return response.data as OverviewApiResponse;
  } catch (error: any) {
    console.error('Error fetching overview revenue:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch overview revenue');
  }
};

export interface GetOverviewWebsiteRevenueParams extends GetOverviewRevenueParams {
  networkId: number;
}

// Récupérer les données de revenus par website pour un network spécifique
export const getOverviewWebsiteRevenue = async (params: GetOverviewWebsiteRevenueParams): Promise<WebsiteOverviewApiResponse> => {
  try {
    const queryParams = new URLSearchParams({
      solution: params.solution,
      period: params.period,
      showVariation: params.showVariation.toString(),
      networkId: params.networkId.toString()
    });

    // Ajouter les dates personnalisées si période est 'custom'
    if (params.period === 'custom') {
      if (params.customStartDate) {
        queryParams.append('customStartDate', params.customStartDate);
      }
      if (params.customEndDate) {
        queryParams.append('customEndDate', params.customEndDate);
      }
    }

    const response = await axiosInstance.get(`/overview/revenue/websites?${queryParams.toString()}`);
    return response.data as WebsiteOverviewApiResponse;
  } catch (error: any) {
    console.error('Error fetching overview website revenue:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch overview website revenue');
  }
};